import { Link } from 'react-router-dom';

export function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20flowing%20golden%20and%20cream%20shapes%2C%20soft%20curves%2C%20minimalist%20elegant%20texture%2C%20light%20airy%20atmosphere%2C%20high%20resolution%2C%20abstract%20background%2C%20no%20text&width=1800&height=600&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 to-primary-800/90"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          准备好开始创作了吗？
        </h2>
        <p className="text-background-50/80 text-sm mb-8 max-w-lg mx-auto leading-relaxed">
          立即注册一起草，体验AI驱动的智能创作。免费版每日3篇文章，无需任何费用即可开始。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="/register"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 text-primary-700 font-medium rounded-lg hover:bg-background-100 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-rocket-line"></i>
            免费注册，立即体验
          </a>
          <Link
            to="/about"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-transparent border border-background-50/30 text-background-50 font-medium rounded-lg hover:bg-background-50/10 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}